import React, { ElementType, forwardRef, ReactNode } from 'react';

import { alpha, styled } from '@mui/material';
import { Link } from 'react-router-dom';

import { FALLBACK_LINK } from '~/routes';
import { BIG_RADIUS_PX, SUBMIDDLE_MARGIN_PX, TINY_MARGIN_PX } from '~/theme';

interface SkillProps {
  children: ReactNode;
  as?: ElementType;
  link?: string;
}

const Skill = forwardRef<HTMLAnchorElement, SkillProps>(({ children, as, link, ...props }, ref) => {
  return (
    <Wrapper ref={ref} to={link || FALLBACK_LINK} as={as || Link} {...props}>
      {children}
    </Wrapper>
  );
});

export default Skill;

const Wrapper = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'as',
})`
  color: ${({ theme }) => theme.palette.common.header.userAvatar.yellow.background};
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  padding: ${TINY_MARGIN_PX} ${SUBMIDDLE_MARGIN_PX};
  background-color: ${({ theme }) => theme.palette.common.subcategories};
  border-radius: ${BIG_RADIUS_PX};
  max-width: max-content;
  transition: color 0.3s;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.common.card.dark.bg};
    box-shadow: 0px 2px 5px 0px ${({ theme }) => alpha(theme.palette.common.accentShadow, 0.3)};
  }
`;
